"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plans = void 0;
const react_1 = __importStar(require("react"));
const plan_card_1 = require("./components/plan-card/plan-card");
const utils_1 = require("./utils");
require("./plans.css");
const colorDefault = "#5C0F8B";
;
/**
 * Main component.
 * @name plans
 * @param {PlansProps}
 * @returns {<Plans />}
*/
const Plans = ({ plans, selectedPlan, onChange, color = colorDefault, assistsHeight = "55px", coveragesHeight = "inherit" }) => {
    const [plansList, setPlans] = (0, react_1.useState)(plans);
    const handleClick = (id) => {
        let array = [...plansList];
        array.forEach((value, i) => {
            if (value.id !== id) {
                array[i].selected = false;
            }
            else {
                array[i].selected = true;
            }
        });
        onChange(id);
        setPlans(array);
    };
    const isSelected = (id) => {
        return id === selectedPlan ? true : false;
    };
    return (react_1.default.createElement("div", { className: "plans-container", "data-testid": "plans-element" },
        react_1.default.createElement("div", { className: "d-md-grid plans-desktop" }, utils_1.utils.renderPlans(plans, selectedPlan, color, handleClick, assistsHeight, coveragesHeight)),
        react_1.default.createElement("div", { className: "d-md-none" },
            react_1.default.createElement("div", { className: "plan-button-container" }, utils_1.utils.renderPlansMobileHeaders(plans, selectedPlan, color, onChange)),
            react_1.default.createElement(plan_card_1.PlanCard, { id: plans[selectedPlan].id, name: plans[selectedPlan].name, price: plans[selectedPlan].price, coverages: plans[selectedPlan].coverages, recomended: plans[selectedPlan].recomended, color: color, assists: plans[selectedPlan].assists, selected: isSelected(plans[selectedPlan].id), key: plans[selectedPlan].id, onChange: () => handleClick(plans[selectedPlan].id), minAge: plans[selectedPlan].minAge, maxAge: plans[selectedPlan].maxAge }))));
};
exports.Plans = Plans;
//# sourceMappingURL=plans.js.map